import { __export } from './chunk-T36PI2YV.mjs';

// src/state/selectors/appSelectors.ts
var appSelectors_exports = {};
__export(appSelectors_exports, {
  selectConfirmationModal: () => selectConfirmationModal,
  selectIsClockInSuggestionModalOpen: () => selectIsClockInSuggestionModalOpen,
  selectIsLoading: () => selectIsLoading,
  selectIsLoadingApiCall: () => selectIsLoadingApiCall,
  selectIsLoadingModal: () => selectIsLoadingModal,
  selectIsRefreshToastActive: () => selectIsRefreshToastActive,
  selectLatestPaymentInformation: () => selectLatestPaymentInformation,
  selectPopoverData: () => selectPopoverData,
  selectRefreshToast: () => selectRefreshToast
});
var selectIsLoading = (state) => state.app.isLoading;
var selectConfirmationModal = (state) => state.app.confirmationModal;
var selectPopoverData = (state) => state.app.popover;
var selectIsClockInSuggestionModalOpen = (state) => state.app.isClockInSuggestionModalOpen;
var selectRefreshToast = (state) => state.app.refreshToast;
var selectIsRefreshToastActive = (state) => selectRefreshToast(state).isActive;
var selectIsLoadingModal = (state) => state.app.isLoadingModal;
var selectIsLoadingApiCall = (state) => selectIsLoadingModal(state).isMakingApiCall;
var selectLatestPaymentInformation = (state) => state.app.latestPaymentInformation;

export { appSelectors_exports, selectConfirmationModal, selectIsClockInSuggestionModalOpen, selectIsLoading, selectIsLoadingApiCall, selectIsLoadingModal, selectIsRefreshToastActive, selectLatestPaymentInformation, selectPopoverData, selectRefreshToast };
